module.exports = __webpack_public_path__ + "static/72invgde-e6df27498f9fd7cfa9c2f6f9c9599b0a.gif";